import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';

import { UnidataTable, Modal } from '~/components';
import {
    recordFiltering,
    refresh
} from '~/store/modules/turnoAcompanhamento/actions';
import { parseISO, format } from 'date-fns';
import { number } from '~/helpers';


export default function TurnoAcompanhamento() {

    const dispatch = useDispatch();

    const theme = useTheme();

    const data = useSelector((state) => state.turnoAcompanhamento);

    const handleColor = useCallback((value) => {

        if (value.status_turno == 'Aberto') {
            return { color: theme.palette.success.main }
        } else {
            return { color: theme.palette.error.main }
        }

    }, [])

    const handleRequest = useCallback(() => {
        dispatch(refresh())
    }, [])


    useEffect(() => {
        const interval = setInterval(() => {
            handleRequest();
        }, 30000)

        return () => {
            clearInterval(interval)
        }
    }, [data.params])



    const header = useMemo(
        () => [
            {
                id: 'poco_descricao',
                label: 'Posto',
                align: 'center',
                filter: {
                    type: 'text'
                }

            },
            {
                id: 'data_turno',
                label: 'Data Turno',
                formatted: (value) =>
                    value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : value,
            },

            {
                id: 'status_turno',
                label: 'Status',
                align: 'center',
                filter: {
                    type: 'select',
                    options: [
                        { label: 'Fechado', value: 'Fechado' },
                        { label: 'Aberto', value: 'Aberto' }
                    ]
                },
                styled: (value) => handleColor(value)
            },
            {
                id: 'prod_descricao',
                align: 'center',
                label: 'Produto',
                filter: {
                    type: 'text'
                }
            },
            {
                id: 'tafi_capacidade',
                label: 'Capacidade',
                align: 'center',

            },
            {
                id: 'tafi_volume_cont',
                label: 'Volume Contábil',
                align: 'center',

            },
            {
                id: '% volume',
                label: 'Volume',
                align: 'center',
                formatted: (value) => value ? number(value, 2) + '%' : value,
            },
            {
                id: 'muni_nome',
                label: 'Município',
                align: 'center',
                filter: {
                    type: 'text'

                }
            },
        ],
        []
    );

    return (
        <>
            <UnidataTable
                pdf
                excel
                reportOrder="poco_codigo ASC"
                fixed
                update={false}
                delete={false}
                create={false}
                read={recordFiltering}
                redux={data}
                header={header}
                detach="poco_descricao"
                keys={['poco_codigo', 'poco_descricao', 'prod_codigo']}
                view="VW_STATUS_TURNO_7_2_28_2_TELA"
                reportTitle="Turno Acompanhamento"
            />

        </>

    );
}
